// extracted by mini-css-extract-plugin
module.exports = {"root":"wc-promotion-button_root__X0Y3h","primary":"wc-promotion-button_primary__0OL7V","outline":"wc-promotion-button_outline___hXdU"};